<template>
  <div>
    <v-rating
      :length="11"
      v-model="internal_value"
      class="rounded-lg mr-2 border--lighttext border--thin"
      color="secondary"
    >
      <template v-slot:item="props">
        <v-btn
          large
          :text="props.index != props.value - 1"
          tile
          class="px-0"
          :color="props.index == props.value - 1 ? 'secondary' : 'lighttext'"
          v-on="!disabled ? { click: props.click } : {}"
        >
          {{ props.index }}
        </v-btn>
      </template>
    </v-rating>
    <v-row dense class="caption">
      <v-col cols="auto">
        Strongly Disagree
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto" class="mr-2">
        Strongly Agree
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Rating",
  components: {},
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: { type: Number },
    disabled: { type: Boolean, default: false }
  },
  data: () => ({
    valueToSave: null
  }),
  computed: {
    internal_value: {
      get() {
        let val = this.value;
        if (val == "" || val == null || val == undefined) {
          return null;
        }
        return parseInt(val) + 1;
      },
      set(val) {
        this.$emit("change", val - 1);
      }
    },
    ...mapGetters({})
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.v-rating {
  height: 40px;

  .v-btn {
    min-width: 32px !important;
    height: calc(100% + 1px) !important;
    margin-top: -1px;

    @media (max-width: 576px) {
      min-width: 27px !important;
    }

    @media (max-width: 400px) {
      min-width: 24px !important;
    }

    &:first-child {
      border-radius: 5px 0 0 5px;
    }

    &:last-child {
      margin-right: -1px;
      border-radius: 0 5px 5px 0;
    }
  }
}

.row.caption {
  font-size: 0.6rem !important;
}
</style>
